import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetrics = ({ metrics }) => {
  const getMetricIcon = (type) => {
    switch (type) {
      case 'pnl': return 'DollarSign';
      case 'volume': return 'BarChart3';
      case 'volatility': return 'Activity';
      case 'correlation': return 'GitBranch';
      default: return 'TrendingUp';
    }
  };

  const getMetricColor = (value, type) => {
    if (type === 'pnl') {
      return value >= 0 ? 'text-success' : 'text-error';
    }
    return 'text-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Performance Metrics</h3>
      <div className="grid grid-cols-2 gap-4">
        {metrics?.map((metric) => (
          <div key={metric?.id} className="space-y-2">
            <div className="flex items-center gap-2">
              <Icon 
                name={getMetricIcon(metric?.type)} 
                size={16} 
                className="text-muted-foreground" 
              />
              <span className="text-sm text-muted-foreground">{metric?.label}</span>
            </div>
            
            <div className="flex items-baseline gap-2">
              <span className={`text-xl font-bold ${getMetricColor(metric?.value, metric?.type)}`}>
                {metric?.value}
              </span>
              <span className="text-sm text-muted-foreground">{metric?.unit}</span>
            </div>
            
            {metric?.change && (
              <div className={`flex items-center gap-1 text-sm ${
                metric?.change >= 0 ? 'text-success' : 'text-error'
              }`}>
                <Icon 
                  name={metric?.change >= 0 ? 'ArrowUp' : 'ArrowDown'} 
                  size={12} 
                />
                <span>{Math.abs(metric?.change)}%</span>
                <span className="text-muted-foreground">vs yesterday</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PerformanceMetrics;